var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-toggle":_vm.isTruncated ? 'tooltip-text' : null,"data-original-title":_vm.isTruncated ? _vm.normalized : null,"data-placement":"top"}},[_vm._v(_vm._s(_vm.displayed))])}
var staticRenderFns = []

export { render, staticRenderFns }